import React, { useState } from "react";
import PropTypes from "prop-types";

// helpers:
import { convertPxToRem } from "frontend/components/helpers";

// components:
import Button from "core/Button";
import BodyText from "core/BodyText";
import FormInput from "core/FormInput";
import FormSelect from "core/FormSelect";
import FormTextArea from "core/FormTextArea";

// styles:
import { Form, CancelButton } from "./styles";

import { getAllTeams } from "./helpers";

const CreateKit = ({
    initialForm,
    handleCancelClick,
    username,
    ownedTeams
}) => {
    // form pieces follow frontend/components/photos/PhotoCheckout/index.js
    const [form, setForm] = useState(initialForm);
    const [formError, setFormError] = useState(null);

    const allOwnedTeams = getAllTeams({ username, ownedTeams });
    const showOwnerSelect = ownedTeams && ownedTeams.length > 0;

    const handleFormChange = (value, fieldName) => {
        setForm({ ...form, [fieldName]: value });
        setFormError(null);
    };

    //todo: add error handling when mutation/query is ready

    const handleFormSubmit = e => {
        e.preventDefault(); // todo: remove this
        //todo: add submit functionality when mutation/query is ready
        //todo: assign new team to username if !ownedTeams and do not show owner dropdown
    };

    return (
        <Form>
            <FormInput
                value={form.name_of_kit}
                onChange={value => handleFormChange(value, "name_of_kit")}
                placeholderText="Name of Kit"
                labelText="Name of Kit"
            />

            <FormSelect
                onChange={value => handleFormChange(value, "privacy")}
                selectName="privacy"
                placeholderText="Select Privacy"
                labelText="Select Privacy"
                options={[{ option: "Public" }, { option: "Private" }]}
            />

            {/* only if user owns teams, show teams to apply ownership of kit:  */}
            {showOwnerSelect && (
                <FormSelect
                    onChange={value => handleFormChange(value, "owner")}
                    selectName="owner"
                    placeholderText="Select Owner"
                    labelText="Select Owner"
                    options={allOwnedTeams}
                />
            )}

            <FormTextArea
                value={form.description}
                onChange={value => handleFormChange(value, "description")}
                placeholderText="Description"
                labelText="Description"
                height={convertPxToRem({ px: 115 })}
            />

            <Button onClick={handleFormSubmit} width="100%" type="submit">
                Create Kit
            </Button>

            <BodyText size="md" type="div" alignment="center">
                <CancelButton onClick={handleCancelClick}>
                    Back to all kits
                </CancelButton>
            </BodyText>
        </Form>
    );
};

CreateKit.propTypes = {
    initialForm: PropTypes.object.isRequired,
    handleCancelClick: PropTypes.func.isRequired,
    username: PropTypes.string,
    ownedTeams: PropTypes.arrayOf(
        PropTypes.shape({
            option: PropTypes.string,
            slug: PropTypes.string
        })
    )
};

export default CreateKit;
